export const KanbanType = {
  TASK: 'TASK',
  PROJECT: 'PROJECT',
  RESOURCE: 'RESOURCE',
  COMPANY: 'COMPANY',
  FEEDBACK: 'FEEDBACK',
  TASKLIST: 'TASKLIST',
  RESOURCETHREE: 'RESOURCETHREE',
};

export const SubMenuUrl = {
  [KanbanType.RESOURCE]: 'resourceOne',
  [KanbanType.FEEDBACK]: 'taskFeedback',
  [KanbanType.PROJECT]: 'Project',
  [KanbanType.TASK]: 'simpleTask',
  [KanbanType.TASKLIST]: 'taskList',
  [KanbanType.RESOURCETHREE]: 'resourceThree',
};

export const RespType = {
  CHIEF: 'CHIEF',
  OTHER: 'OTHER',
};

export const OptionalKanbanTypes = [KanbanType.RESOURCETHREE];

export const ResponsiblePersonVisibleForTypes = [KanbanType.TASK, KanbanType.TASKLIST];

export const AddIconVisibleForTypes = [KanbanType.TASK, KanbanType.PROJECT];

export const PriorityVisibleForTypes = [KanbanType.TASK, KanbanType.FEEDBACK];

export const TagEnabledForTypes = [KanbanType.TASK, KanbanType.PROJECT];

export const KanbanTypeToSubMenuUrl = {
  [KanbanType.RESOURCE]: SubMenuUrl.RESOURCE,
  [KanbanType.FEEDBACK]: SubMenuUrl.FEEDBACK,
  [KanbanType.PROJECT]: SubMenuUrl.PROJECT,
  [KanbanType.TASK]: SubMenuUrl.TASK,
  [KanbanType.TASKLIST]: SubMenuUrl.TASKLIST,
  [KanbanType.RESOURCETHREE]: SubMenuUrl.RESOURCETHREE,
};

export const KanbanTypeToPermissionSubMenuUrl = {
  ...KanbanTypeToSubMenuUrl,
  [KanbanType.TASKLIST]: 'projectTasks',
};

export const NavigateUrlToKanbanType = {
  simpleTask: KanbanType.TASK,
  Project: KanbanType.PROJECT,
  resource: KanbanType.RESOURCE,
  company: KanbanType.COMPANY,
  taskFeedback: KanbanType.FEEDBACK,
  taskList: KanbanType.TASKLIST,
  resourceThree: KanbanType.RESOURCETHREE,
};

const ViewConfig = {
  task: { label: 'Feladatok', value: KanbanType.TASK },
  project: { label: 'Projektek', value: KanbanType.PROJECT },
  resource: { label: 'Erőforrás 1', value: KanbanType.RESOURCE },
  company: { label: 'Cégek', value: KanbanType.COMPANY },
  taskFeedback: { label: 'Feedback', value: KanbanType.FEEDBACK },
  taskList: { label: 'Feladatlista', value: KanbanType.TASKLIST },
  resourceThree: { label: 'Erőforrás 3', value: KanbanType.RESOURCETHREE },
};

export const ViewType = [
  ViewConfig.task,
  ViewConfig.project,
  ViewConfig.resource,
  ViewConfig.taskFeedback,
  ViewConfig.taskList,
  ViewConfig.resourceThree,
];
export const FunnelViewType = [ViewConfig.task, ViewConfig.project, ViewConfig.resource, ViewConfig.company];

export const KanbanCard = [
  { type: KanbanType.TASK, paramName: 'KANBAN_TASK_CARD_CONTENT', colorField: 'priorityColor' },
  { type: KanbanType.PROJECT, paramName: 'KANBAN_PROJECT_CARD_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.RESOURCE, paramName: 'KANBAN_RESOURCE_CARD_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.COMPANY, paramName: 'KANBAN_COMPANY_CARD_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.FEEDBACK, paramName: 'KANBAN_FEEDBACK_CARD_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.TASKLIST, paramName: 'KANBAN_TASKLIST_CARD_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.RESOURCETHREE, paramName: 'KANBAN_RESOURCETHREE_CARD_CONTENT', colorField: 'statusColor' },
];

export const KanbanDialog = [
  { type: KanbanType.TASK, paramName: 'KANBAN_TASK_DIALOG_CONTENT', colorField: 'priorityColor' },
  { type: KanbanType.PROJECT, paramName: 'KANBAN_PROJECT_DIALOG_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.RESOURCE, paramName: 'KANBAN_RESOURCE_DIALOG_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.COMPANY, paramName: 'KANBAN_COMPANY_DIALOG_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.FEEDBACK, paramName: 'KANBAN_FEEDBACK_DIALOG_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.TASKLIST, paramName: 'KANBAN_TASKLIST_DIALOG_CONTENT', colorField: 'statusColor' },
  { type: KanbanType.RESOURCETHREE, paramName: 'KANBAN_RESOURCETHREE_DIALOG_CONTENT', colorField: 'statusColor' },
];

export const conditions = {
  [KanbanType.TASK]: {
    like: ['simpleTaskName'],
    lte: ['endDate'],
  },
  [KanbanType.PROJECT]: {
    like: ['projectName'],
  },
  [KanbanType.RESOURCE]: {
    like: ['name'],
  },
  [KanbanType.COMPANY]: {
    like: ['name'],
  },
  [KanbanType.FEEDBACK]: {
    like: ['name'],
  },
  [KanbanType.TASKLIST]: {
    like: ['name'],
  },
  [KanbanType.RESOURCETHREE]: {
    like: ['name'],
  },
};

export const KanbanFilterFormState = {
  [KanbanType.TASK]: {
    simpleTaskName: '',
    resposiblePersonId: '',
  },
  [KanbanType.PROJECT]: {
    projectName: '',
    companyId: '',
    projectTypeId: '',
  },
  [KanbanType.RESOURCE]: {
    name: '',
  },
  [KanbanType.COMPANY]: {
    name: '',
  },
  [KanbanType.FEEDBACK]: {
    name: '',
  },
  [KanbanType.TASKLIST]: {
    name: '',
    responsiblePersonId: '',
    lineId: '',
  },
  [KanbanType.RESOURCETHREE]: {
    name: '',
  },
};

export const filterFieldConfig = {
  fields: {
    simpleTaskName: {
      label: 'Név',
      types: [KanbanType.TASK],
      control: 'textLike',
    },
    projectName: {
      label: 'Név',
      types: [KanbanType.PROJECT],
      control: 'textLike',
    },
    name: {
      label: 'Név',
      types: [
        KanbanType.RESOURCE,
        KanbanType.RESOURCETHREE,
        KanbanType.COMPANY,
        KanbanType.FEEDBACK,
        KanbanType.TASKLIST,
      ],
      control: 'textLike',
    },
    companyId: {
      label: 'Cég',
      types: [KanbanType.PROJECT],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'company',
      getDisabled: () => false,
    },
    projectTypeId: {
      label: 'Projekt típus',
      types: [KanbanType.PROJECT, KanbanType.TASKLIST],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'projectType',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.TASKLIST) return params.TASKLIST_KANBAN_SHOW_PROJECT_TYPE_FIELD === 'Y';

        return true;
      },
    },
    resposiblePersonId: {
      label: 'Felelős',
      types: [KanbanType.TASK],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'user',
      getDisabled: (roles) => roles.TASK_KANBAN_SEE_ONLY_OWN,
    },
    responsible: {
      label: 'Felelős',
      types: [KanbanType.TASKLIST],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'responsible',
      getDisabled: (roles) => roles.TASKLIST_KANBAN_SEE_ONLY_OWN || roles.TASKLIST_KANBAN_SEE_ONLY_OWN_AND_GROUP,
    },
    lineId: {
      label: 'Projekt',
      types: [KanbanType.TASKLIST],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'project',
      getDisabled: () => false,
    },
    userId: {
      label: 'Tulajdonos',
      types: [KanbanType.TASKLIST, KanbanType.TASK],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'user',
      getDisabled: (roles) => roles.TASK_KANBAN_SEE_ONLY_OWNED,
    },
    createdBy: {
      label: 'Tulajdonos',
      types: [KanbanType.FEEDBACK],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'user',
      getDisabled: (roles) => roles.FEEDBACK_KANBAN_SEE_ONLY_OWNED,
    },
    userGroupId: {
      label: 'Felelősök (cs.)',
      types: [KanbanType.TASKLIST],
      widthClass: 'w-full md:w-[120px]',
      control: 'multiAutocomplete',
      optionsKey: 'userGroup',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.TASKLIST) return params.TASKLIST_KANBAN_SHOW_USER_GROUP_FIELD === 'Y';

        return false;
      },
    },
    relevantDepartmentId: {
      label: 'Érintett részleg',
      types: [KanbanType.FEEDBACK],
      widthClass: 'w-full md:w-[230px]',
      control: 'multiAutocomplete',
      optionsKey: 'userGroup',
      getDisabled: (roles) => roles.FEEDBACK_KANBAN_SEE_ONLY_OWN,
    },
    onlyHeadTasks: {
      label: 'FF.',
      types: [KanbanType.TASKLIST],
      widthClass: 'w-full md:w-[80px]',
      control: 'switch',
      getDisabled: () => false,
    },
    classificationId: {
      label: 'Besorolás',
      types: [KanbanType.PROJECT],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'classification',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.PROJECT) return params.PROJECT_KANBAN_SHOW_CLASSIFICATION_FIELD === 'Y';

        return false;
      },
    },
    projectId: {
      label: 'Projekt',
      types: [KanbanType.TASK],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'project',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.TASK) return params.TASK_KANBAN_SHOW_PROJECT_FIELD === 'Y';

        return false;
      },
    },
    endDate: {
      label: 'Határidő (-ig)',
      types: [KanbanType.TASK],
      widthClass: 'w-full md:w-[120px]',
      control: 'datepicker',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.TASK) return params.TASK_KANBAN_SHOW_ENDDATE_FIELD === 'Y';

        return false;
      },
    },
    priorId: {
      label: 'Prioritás',
      types: [KanbanType.TASK],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'priority',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.TASK) return params.TASK_KANBAN_SHOW_PRIORITY_FIELD === 'Y';

        return false;
      },
    },
    companyLocationId: {
      label: 'Telephely',
      types: [KanbanType.PROJECT],
      widthClass: 'w-full md:w-[110px]',
      control: 'autocomplete',
      optionsKey: 'companyLocation',
      getDisabled: () => false,
      shouldShow: (params, type) => {
        if (type === KanbanType.PROJECT) return params.PROJECT_KANBAN_SHOW_COMPANYLOCATION_FIELD === 'Y';

        return false;
      },
    },
  },
};

export const addButtonByType = [KanbanType.TASK];

export const orderColumnsByType = {
  [KanbanType.TASK]: [
    {
      label: 'Prioritás',
      value: 'priorId',
    },
    {
      label: 'Határidő',
      value: 'endDate',
    },
    {
      label: 'Létrehozás dátuma',
      value: 'createdAt',
    },
    {
      label: 'Módosítás dátuma',
      value: 'updatedAt',
    },
  ],
};
